import { createLocaleMap, locale } from "../util/LocaleUtils";

const locales = createLocaleMap([
	locale("en", "English Base", () => require("./locale.en.json"), {
		technical: true,
	}),
	locale("en-gb", "English (GB)", () => require("./locale.en-gb.json")),
	locale(
		"en-us",
		"English (US)",
		() => import(/* webpackChunkName: "LocaleEN_US" */ "./locale.en-us.json"),
	),
	locale(
		"fr",
		"French Base",
		() => import(/* webpackChunkName: "LocaleFR" */ "./locale.fr.json"),
		{ technical: true },
	),
	locale(
		"fr-fr",
		"Français",
		() => import(/* webpackChunkName: "LocaleFR_FR" */ "./locale.fr-fr.json"),
	),
	locale(
		"es",
		"Spanish Base",
		() => import(/* webpackChunkName: "LocaleES" */ "./locale.es.json"),
		{
			technical: true,
		},
	),
	locale(
		"es-es",
		"Español",
		() => import(/* webpackChunkName: "LocaleES_ES" */ "./locale.es-es.json"),
	),
	locale(
		"ru",
		"Russian Base",
		() => import(/* webpackChunkName: "LocaleRU" */ "./locale.ru.json"),
		{
			technical: true,
		},
	),
	locale(
		"ru-ru",
		"русский",
		() => import(/* webpackChunkName: "LocaleRU_RU" */ "./locale.ru-ru.json"),
	),
	locale(
		"pt",
		"Portuguese Base",
		() => import(/* webpackChunkName: "LocalePT" */ "./locale.pt.json"),
		{
			technical: true,
		},
	),
	locale(
		"pt-br",
		"Português",
		() => import(/* webpackChunkName: "LocalePT_BR" */ "./locale.pt-br.json"),
	),
	locale(
		"it",
		"Italian Base",
		() => import(/* webpackChunkName: "LocaleIT" */ "./locale.it.json"),
		{
			technical: true,
		},
	),
	locale(
		"it-it",
		"Italiano",
		() => import(/* webpackChunkName: "LocaleIT_IT" */ "./locale.it-it.json"),
	),
	locale(
		"tr",
		"Turkish Base",
		() => import(/* webpackChunkName: "LocaleTR" */ "./locale.tr.json"),
		{
			technical: true,
		},
	),
	locale(
		"tr-tr",
		"Türkçe",
		() => import(/* webpackChunkName: "LocaleTR_TR" */ "./locale.tr-tr.json"),
	),
	locale(
		"he",
		"Hebrew Base",
		() => import(/* webpackChunkName: "LocaleHE" */ "./locale.he.json"),
		{
			technical: true,
			dir: "rtl",
		},
	),
	locale(
		"he-il",
		"עִברִית",
		() => import(/* webpackChunkName: "LocaleHE_IL" */ "./locale.he-il.json"),
		{
			dir: "rtl",
		},
	),
	locale(
		"de",
		"German Base",
		() => import(/* webpackChunkName: "LocaleDE" */ "./locale.de.json"),
		{
			technical: true,
		},
	),
	locale(
		"de-de",
		"Deutsch",
		() => import(/* webpackChunkName: "LocaleDE_DE" */ "./locale.de-de.json"),
	),
	locale(
		"nl",
		"Dutch Base",
		() => import(/* webpackChunkName: "LocaleNL" */ "./locale.nl.json"),
		{
			technical: true,
		},
	),
	locale(
		"nl-nl",
		"Nederlands",
		() => import(/* webpackChunkName: "LocaleNL_NL" */ "./locale.nl-nl.json"),
	),
	locale(
		"ro",
		"Romanian Base",
		() => import(/* webpackChunkName: "LocaleRO" */ "./locale.ro.json"),
		{
			technical: true,
		},
	),
	locale(
		"ro-ro",
		"Română",
		() => import(/* webpackChunkName: "LocaleRO_RO" */ "./locale.ro-ro.json"),
	),
	locale(
		"vi",
		"Vietnamese Base",
		() => import(/* webpackChunkName: "LocaleVI" */ "./locale.vi.json"),
		{
			technical: true,
		},
	),
	locale(
		"vi-vi",
		"Tiếng Việt",
		() => import(/* webpackChunkName: "LocaleVI_VI" */ "./locale.vi-vi.json"),
		{
			technical: true,
		},
	),
	locale(
		"zh",
		"Chinese Base",
		() => import(/* webpackChunkName: "LocaleZH" */ "./locale.zh.json"),
		{
			technical: true,
		},
	),
	locale(
		"zh-zh",
		"中国人",
		() => import(/* webpackChunkName: "LocaleZH_ZH" */ "./locale.zh-zh.json"),
		{
			technical: true,
		},
	),
	locale(
		"km",
		"Khmer Base",
		() => import(/* webpackChunkName: "LocaleZH" */ "./locale.km.json"),
		{
			technical: true,
		},
	),
	locale(
		"km-km",
		"ខ្មែរ",
		() => import(/* webpackChunkName: "LocaleZH_ZH" */ "./locale.km-km.json"),
		{
			technical: true,
		},
	),
	locale(
		"pl",
		"Polish Base",
		() => import(/* webpackChunkName: "LocaleRO" */ "./locale.pl.json"),
		{
			technical: true,
		},
	),
	locale(
		"pl-pl",
		"Polska",
		() => import(/* webpackChunkName: "LocaleRO_RO" */ "./locale.pl-pl.json"),
	),
	locale(
		"el",
		"Greek Base",
		() => import(/* webpackChunkName: "LocaleEL" */ "./locale.el.json"),
		{
			technical: true,
		},
	),
	locale(
		"el-el",
		"Ελληνικά",
		() => import(/* webpackChunkName: "LocaleEL_EL" */ "./locale.el-el.json"),
		{
			technical: true,
		},
	),
	locale(
		"ar",
		"Arabic Base",
		() => import(/* webpackChunkName: "LocaleAR" */ "./locale.ar.json"),
		{
			technical: true,
			dir: "rtl",
		},
	),
	locale(
		"ar-ar",
		"عربي",
		() => import(/* webpackChunkName: "LocaleAR_AR" */ "./locale.ar-ar.json"),
		{
			technical: true,
			dir: "rtl",
		},
	),
	locale(
		"da",
		"Danish Base",
		() => import(/* webpackChunkName: "LocaleDA" */ "./locale.da.json"),
		{
			technical: true,
		},
	),
	locale(
		"da-dk",
		"Dansk",
		() => import(/* webpackChunkName: "LocaleDA_DK" */ "./locale.da-dk.json"),
		{
			technical: true,
		},
	),
	locale(
		"id",
		"Indonesian Base",
		() => import(/* webpackChunkName: "LocaleID" */ "./locale.id.json"),
		{
			technical: true,
		},
	),
	locale(
		"id-id",
		"Bahasa Indonesia",
		() => import(/* webpackChunkName: "LocaleID_ID" */ "./locale.id-id.json"),
		{
			technical: true,
		},
	),
	locale(
		"hu",
		"Hungarian Base",
		() => import(/* webpackChunkName: "LocaleHU" */ "./locale.hu.json"),
		{
			technical: true,
		},
	),
	locale(
		"hu-hu",
		"Hungarian",
		() => import(/* webpackChunkName: "LocaleHU_HU" */ "./locale.hu-hu.json"),
		{
			technical: true,
		},
	),
	locale(
		"tg",
		"Filipino Base",
		() => import(/* webpackChunkName: "LocaleTG" */ "./locale.tg.json"),
		{
			technical: true,
		},
	),
	locale(
		"tg-ph",
		"Filipino",
		() => import(/* webpackChunkName: "LocaleTG_PH" */ "./locale.tg-ph.json"),
		{
			technical: true,
		},
	),
	locale(
		"fil",
		"Filipino",
		() => import(/* webpackChunkName: "LocaleTG_PH" */ "./locale.tg.json"),
		{
			technical: true,
		},
	),
	locale(
		"fil-ph",
		"Filipino",
		() => import(/* webpackChunkName: "LocaleFIL_PH" */ "./locale.tg.json"),
		{
			technical: true,
		},
	),
	locale(
		"th",
		"Thai Base",
		() => import(/* webpackChunkName: "LocaleTH" */ "./locale.th.json"),
		{
			technical: true,
		},
	),
	locale(
		"th-th",
		"Thai",
		() => import(/* webpackChunkName: "LocaleTH_TH" */ "./locale.th.json"),
		{
			technical: true,
		},
	),
	locale(
		"ja",
		"Japanese Base",
		() => import(/* webpackChunkName: "LocaleJA" */ "./locale.ja.json"),
		{
			technical: true,
		},
	),
	locale(
		"ja-jp",
		"Japanese",
		() => import(/* webpackChunkName: "LocaleJA_JP" */ "./locale.ja-jp.json"),
		{
			technical: true,
		},
	),
	locale(
		"ko",
		"Korean Base",
		() => import(/* webpackChunkName: "LocaleKO" */ "./locale.ko.json"),
		{
			technical: true,
		},
	),
	locale(
		"ko-kr",
		"Korean",
		() => import(/* webpackChunkName: "LocaleKO_KR" */ "./locale.ko-kr.json"),
		{
			technical: true,
		},
	),
]);

export default locales;
